var exports = {
  "RZ": "delegationNote__9PYC4I",
  "s3": "teamList__ZulM6-",
  "me": "separator__kF7eb1",
};

module.exports = exports;
